import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCoreTableContext } from "../CoreTable";

const CorePagination = (props) => {
  const { table, pagination } = useCoreTableContext();
  const { t } = useTranslation("uaa");
  const { pageIndex, pageSize } = pagination;
  const { onChangePagination, totalItem, isPaginationLocal, customStyle } = props;
  const { pageSize: pgSize, pageIndex: pgIndex } = table.getState().pagination;

  const numberPages = totalItem
    ? Math.ceil(totalItem / (isPaginationLocal ? pgSize : pageSize))
    : 0;
  const isFirstPage = isPaginationLocal ? !pgIndex : !pageIndex;
  const isLastPage = isPaginationLocal
    ? pgIndex === numberPages - 1
    : pageIndex === numberPages - 1;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNext = () => {
    if (!isLastPage) {
      isPaginationLocal
        ? table.setPageIndex((prev) => prev + 1)
        : onChangePagination({
          page: pageIndex + 2,
          size: pageSize,
        });
    }
  };

  const handlePrev = () => {
    if (!isFirstPage) {
      isPaginationLocal
        ? table.setPageIndex((prev) => prev - 1)
        : onChangePagination({
          page: pageIndex,
          size: pageSize,
        });
    }
  };

  const handleJumpToFirst = async () => {
    isPaginationLocal
      ? table.setPageIndex(0)
      : onChangePagination({
        page: 1,
        size: pageSize,
      });
  };

  const handleJumpToLast = () => {
    isPaginationLocal
      ? table.setPageIndex(numberPages - 1)
      : onChangePagination({
        page: numberPages,
        size: pageSize,
      });
  };

  const open = Boolean(anchorEl);

  return (
    <Box className="flex items-center justify-center mt-10 flex-1 flex-wrap gap-10">
      <Box className="flex items-center">
        <Typography variant="body2">{t("table.paginationNumber")}</Typography>
        <Button onClick={handleClick}>
          {isPaginationLocal ? pgSize : pageSize} <KeyboardArrowDownIcon />
        </Button>
        <Box sx={{ p: 2 }}>
          <Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
            {customStyle ? (
              [15, 30, 60, 100]?.map((item, index) => {
                return (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      handleClose();
                      isPaginationLocal
                        ? table.setPageSize(item)
                        : onChangePagination({
                          size: item,
                        });
                    }}
                  >
                    {item}
                  </MenuItem>
                );
              })
            ) : (
              [10, 20, 50, 100]?.map((item, index) => {
                return (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      handleClose();
                      isPaginationLocal
                        ? table.setPageSize(item)
                        : onChangePagination({
                          size: item,
                        });
                    }}
                  >
                    {item}
                  </MenuItem>
                );
              })
            )}
          </Menu>
        </Box>
      </Box>
      <Box className="flex items-center gap-[4px] ">
        <Button
          disabled={isFirstPage || !totalItem}
          onClick={handleJumpToFirst}
          className="bg-slate-200 "
        >
          <KeyboardDoubleArrowLeftIcon className="text-[18px]" />
        </Button>

        <Button
          className="bg-slate-200"
          disabled={isFirstPage || !totalItem}
          onClick={handlePrev}
        >
          <KeyboardArrowLeftIcon className="text-[18px]" />
        </Button>

        <Button
          className="bg-slate-200 text-[black]"
        // disabled={isFirstPage || !totalItem}
        // onClick={handlePrev}
        >
          {t("table.page")} {isPaginationLocal ? pgIndex + 1 : pageIndex + 1} /{" "}
          {numberPages} ({`${totalItem} ${t("table.items")}`})
        </Button>

        {/* <div className="text-[14px] bg-slate-200">
          {t("table.page")} {isPaginationLocal ? pgIndex + 1 : pageIndex + 1} /{" "}
          {numberPages} ({`${totalItem} ${t("table.items")}`})
        </div> */}

        <Button
          className="bg-slate-200"
          disabled={isLastPage || !totalItem}
          onClick={handleNext}
        >
          <KeyboardArrowRightIcon className="text-[18px]" />
        </Button>

        <Button
          className="bg-slate-200"
          disabled={isLastPage || !totalItem}
          onClick={handleJumpToLast}
        >
          <KeyboardDoubleArrowRightIcon className="text-[18px]" />
        </Button>
      </Box>
    </Box>
  );
};

export default CorePagination;
